import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import flowStarter from '~root/src/web-components/flow-starter/flow-starter.vue?shadow'
window.customElements.define('w2p-flow-starter', wrap(Vue, flowStarter))

import importWizard from '~root/src/web-components/import-wizard/import-wizard.vue?shadow'
window.customElements.define('w2p-import-wizard', wrap(Vue, importWizard))

import importWizardV2 from '~root/src/web-components/import-wizard-v2/import-wizard-v2.vue?shadow'
window.customElements.define('w2p-import-wizard-v2', wrap(Vue, importWizardV2))

import logoLibrary from '~root/src/web-components/logo-library/logo-library.vue?shadow'
window.customElements.define('w2p-logo-library', wrap(Vue, logoLibrary))

import printPositionsManager from '~root/src/web-components/print-positions-manager/print-positions-manager.vue?shadow'
window.customElements.define('w2p-print-positions-manager', wrap(Vue, printPositionsManager))

import uploadLogo from '~root/src/web-components/upload-logo/upload-logo.vue?shadow'
window.customElements.define('w2p-upload-logo', wrap(Vue, uploadLogo))